import { waitForBraze } from '../braze/braze';
import { ContentCard, Contentcards } from '../contentcards/contentcards';
import React, { useEffect, useState } from 'react';

export type BrazeContentCardsProps = {
  keyValuePairs: ContentCardProp[];
  userId: string | undefined;
  className?: string;
};


export type ContentCardProp = {
  key: string;
  value: string;
};

export function BrazeContentCards({
  keyValuePairs,
  userId,
  className,
}: BrazeContentCardsProps) {
  const [braze, setBraze] = useState<any>(null);
  const [activeCards, setActiveCards] = useState<ContentCard[]>([]);

  function subscribeToContentCardsUpdates() {
    if (!braze) {
      console.log(
        '::: Braze: An error occurred while trying to refer to the braze'
      );
      return;
    }
    braze.subscribeToContentCardsUpdates((newCards: any) => {
      console.log(
        `::: Braze: New Cards are arrived: ${newCards.cards.length}`,
        newCards
      );
      if (newCards.cards.length) {
        setActiveCards(newCards.cards);
      } else {
        console.log(`::: Braze: NO New Cards so far`);
      }
    });
    braze.requestContentCardsRefresh();
  }

  function changeUser(userId: string | undefined) {
    braze.getUser().getUserId((id: string | undefined) => {
      if (id === userId || !userId) return;
      braze.changeUser(userId);
    });
  }

  useEffect(() => {
    (async () => {
      const braze = await waitForBraze();
      setBraze(braze);
    })();
  }, []);

  useEffect(() => {
    if (braze && braze.initialize()) {
      subscribeToContentCardsUpdates();
      changeUser(userId);
      braze.requestContentCardsRefresh();
    }
  }, [braze]);

  return (
    <div className={className}>
      <Contentcards cards={activeCards} keyValueParam={keyValuePairs} />
    </div>
  );
}
